<template>
  <view class="tw-scroll-x">
    <scroll-view class="a-w-100% a-overflow-hidden scroll-list-x" scroll-x="true">
      <!-- 插槽元素属性为 inline-block  -->
      <slot></slot>
    </scroll-view>
  </view>
</template>

<script>
export default {
  name: 'index',
};
</script>

<style lang="less" scoped scoped>
/deep/.scroll-list-x {
  white-space: nowrap;
}
</style>
